module.exports = __webpack_public_path__ + "img/UNIFORM RED.e630e46.svg";